import React, { useMemo, useEffect, useState } from "react";
import { useTable, useFilters, usePagination } from "react-table";
import "../../table/FilteringTable/filtering.css";
import { getDefaultParams } from "../../../../services/DefaultParamets";
import Tables from "../components/tables";
import { CurrencyNormalComponent } from "../components/CurrencyComponnet";
import SearchTextWithDateRange from "../components/SearchWithDateRange";
import { SpinnerCitoPlus } from "../components/loadingLogo";
import FacturacionService from "../../../../services/FacturacionService";
import swal from "sweetalert";

export const VigilantesCajas = () => {
  const [smallModalTitle, setSmallModalTitle] = useState("");
  const [smallModalBody, setSmallModalBody] = useState("");
  const [smallShowModal, setSmallShowModal] = useState(false);

  const [loading, setLoading] = useState(true);

  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState("open_at");
  const [order, setOrder] = useState("desc");
  const [nextUrl, setNextUrl] = useState(null);
  const [previousUrl, setPreviousUrl] = useState(null);

  const [defaultParams] = useState(getDefaultParams);
  const [currentFilters, setCurrentFilters] = useState({
    search: "",
    h_ingreso_after: "",
    h_ingreso_before: "",
    h_salida_after: "",
    h_salida_before: "",
  });

  const columns = useMemo(
    () => [
      {
        id: "open_at",
        Header: "Abierta ",
        disableFilters: true,
        disableSortBy: false,
        accessor: "open_at",
      },
      {
        id: "close_at",
        Header: "Cerrada ",
        disableFilters: true,
        disableSortBy: false,
        accessor: "close_at",
      },
      {
        id: "vigilante_nombre",
        Header: "Vigilante ",
        disableFilters: true,
        disableSortable: true,
        accessor: "vigilante_nombre",
      },
      {
        id: "total",
        Header: "Total ",
        disableFilters: true,
        disableSortable: true,
        accessor: "total",
        Cell: ({ value }) =>
          value ? <CurrencyNormalComponent amount={value} /> : 0,
      },
    ],
    [],
  );

  useEffect(() => {
    fetchUrl(1, currentFilters, "-open_at");
  }, []);

  const fetchUrl = async (
    pageIndex = 1,
    filters = currentFilters,
    ordering = [],
  ) => {
    setLoading(true);
    try {
      if (pageIndex < 1 || pageIndex > totalPages) {
        setSmallModalTitle("Error de Página");
        setSmallModalBody("Error de Página");
        setSmallShowModal(true);
        return;
      }
      const response = await FacturacionService.getCajas({
        ...defaultParams,
        ...filters,
        page: pageIndex,
        ordering: ordering,
      });
      setNextUrl(response.data.next);
      setPreviousUrl(response.data.previous);
      setTotalPages(response.data.total_pages);
      setTotalRecords(response.data.count);
      setCurrentPage(response.data.current_page);
      setData(response.data.results);
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 404) {
        setSmallModalTitle("Error");
        setSmallModalBody("No se encontraron datos.");
        setSmallShowModal(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (filters) => {
    setCurrentFilters(filters);
    fetchUrl(1, filters);
  };

  const handleEnterPress = () => {
    // Lógica para manejar la tecla Enter, si es necesario
  };

  const handleClearClick = () => {
    const emptyFilters = {
      search: "",
      h_ingreso_after: "",
      h_ingreso_before: "",
      h_salida_after: "",
      h_salida_before: "",
    };
    handleSearchChange(emptyFilters);
  };

  const handleSortingChange = (column) => {
    const { id } = column;

    const newOrder =
      sortField === id ? (order === "asc" ? "desc" : "asc") : "asc";

    setSortField(id);
    setOrder(newOrder);
    fetchUrl(1, currentFilters, `${newOrder === "desc" ? "-" : ""}${id}`);
  };

  const handleOpenModal = () => {
    setSmallShowModal(true);
  };

  const handleCloseModal = () => {
    setSmallShowModal(false);
  };

  const handleExport = async () => {
    swal("Exportar", "Exportando...", "info");
    try {
      await FacturacionService.exportRecaudo({
        ...currentFilters,
      });
      swal("Éxito", "Exportación completada.", "success");
    } catch (error) {
      console.error("Error exporting data:", error);
      swal("Error", "No se pudo exportar.", "error");
    }
  };

  const tableInstance = useTable(
    {
      columns,
      data,
      manualPagination: true,
      pageCount: totalPages,
    },
    useFilters,
    usePagination,
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
  } = tableInstance;

  return (
    <>
      <section className="card">
        <header className="card-header">
          <div className="d-flex flex-wrap align-items-center gap-2 w-100">
            <div className="d-flex flex-column me-auto flex-grow-1">
              <h2 className="card-title mb-0">Cierre de turno</h2>
              <div className="text-muted small">
                Administra los turnos de caja de vigilantes.
              </div>
            </div>
          </div>
        </header>

        <div className="card-body">
          <div className="row g-3 mb-4">
            <div className="col-lg-4 col-md-6">
              <SearchTextWithDateRange
                onSearchChange={handleSearchChange}
                onEnterPress={handleEnterPress}
                onClearClick={handleClearClick}
                showDatePicker={true}
                placeholder={"Nombre"}
                placeholderText={"Fechas de apertura y cierre"}
              />
            </div>
          </div>

          {loading ? (
            <div className="py-5 text-center">
              <SpinnerCitoPlus text="Cargando turnos..." />
            </div>
          ) : data.length === 0 ? (
            <div className="text-center py-5">
              <i className="fas fa-cash-register fa-3x text-muted mb-3"></i>
              <h5>No hay turnos registrados</h5>
              <p className="text-muted">
                No se encontraron registros con los filtros aplicados.
              </p>
            </div>
          ) : (
            <Tables
              columns={columns}
              data={data}
              loading={loading}
              totalPages={totalPages}
              totalRecords={totalRecords}
              currentPage={currentPage}
              fetchUrl={fetchUrl}
              handleSortingChange={handleSortingChange}
              nextUrl={nextUrl}
              previousUrl={previousUrl}
              sortField={sortField}
              order={order}
              page={page}
            />
          )}
        </div>
      </section>
    </>
  );
};

export default VigilantesCajas;
